export enum Actions {
  SET = "interact-wxcc-set",
  UPDATE = 'interact-wxcc-update',
  RESET = "interact-wxcc-reset",
}
